// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Users } from 'react-feather'

// CSS
import './styles.scss'

// Component/Container
import SwapSearch from './components/SwapSearch'
import SwapCard from './components/SwapCard'
import HeaderPopUp from '../Header/components/HeaderPopUp'

// Validate
import { required } from '../../constants/validate'

// Others
import { accentFolding } from '../../constants/others'

// Actions
import { fetchOperations, changeSwapSearch, pinOperation, swapOperation } from './actions'
import { changeHeaderVisible } from '../Header/actions'
import { profile } from '../ProfilePage/actions'

import withParams from '../../hoc/WithParams'

class Swap extends Component {
  UNSAFE_componentWillMount() {
    const { fetchOperations, user } = this.props
    fetchOperations(user.id)
  }

  handleSearch = (operations) => {
    const { search } = this.props
    let newOperations = []

    const re = new RegExp(accentFolding(search), 'i')

    operations.map(operation => {
      const match = re.exec(operation.label)

      if (match) newOperations = [...newOperations, operation]
    })

    return newOperations
  }

  findCurrentOperation = (operations) => {
    let currentOperation = operations.filter(function (op) {
      return op.current === true
    })
    return currentOperation
  }

  findPinnedOperations = (operations) => {
    let pinnedOperations = operations.filter(function (op) {
      return op.current === false && op.pin === true
    })
    return pinnedOperations
  }

  findUnpinnedOperations = (operations) => {
    let unpinnedOperations = operations.filter(function (op) {
      return op.current === false && op.pin === false
    })
    return unpinnedOperations
  }

  createData = (item) => {
    const { user: { admin, groupId, lawFirmId, capture, id } } = this.props
    let data = { [item.type]: item.label, [`${item.type}Id`]: item.value }

    if ((item.type === 'group' && !lawFirmId && groupId === item.value) || (item.type === 'lawFirm' && lawFirmId === item.value)) return

    if (item.type === 'group') data = { ...data, 'lawFirm': null, 'lawFirmId': null }

    data = { ...data, 'capture': capture }
    data = { ...data, 'userId': id }

    return data
  }

  render() {
    const { user: { admin, groupId, lawFirmId, capture, id }, visible, operations, changeSwapSearch, search, changeHeaderVisible, profile, pinOperation, swapOperation, history } = this.props
    const { handleSearch, findCurrentOperation, findPinnedOperations, findUnpinnedOperations, createData } = this

    return (
      <div>
        {!_.isEmpty(operations) &&
          <div className='swap'>
            <Users size="20" onClick={() => changeHeaderVisible('swap')} className='swap-icon' />
            <div className={visible.status && visible.type === 'swap' ? 'swap-bar swap-bar--visible' : 'swap-bar'}>
              {admin &&
                <div className='swap-bar-search'>
                  <input placeholder='Busca por empresa' value={search} onChange={(e) => changeSwapSearch(e.target.value)}></input>
                </div>}
              {findCurrentOperation(operations).map(item => {
                let data = []
                return (
                  <SwapCard key={item.value} operation={item} pinOperation={pinOperation} userId={id} data={data} swapOperation={swapOperation} history={history} />
                )
              })}
              {!_.isEmpty(findPinnedOperations(operations)) && handleSearch(findPinnedOperations(operations)).map(item => {
                let data = createData(item)
                return (
                  <SwapCard key={item.value} operation={item} pinOperation={pinOperation} userId={id} data={data} swapOperation={swapOperation} history={history} />
                )
              })}
              {!_.isEmpty(findUnpinnedOperations(operations)) && handleSearch(findUnpinnedOperations(operations)).map(item => {
                let data = createData(item)
                return (
                  <SwapCard key={item.value} operation={item} pinOperation={pinOperation} userId={id} data={data} swapOperation={swapOperation} history={history} />
                )
              })}
            </div>
          </div>}
      </div>
    )
  }
}

Swap = connect((state, ownProps) => {
  return {
    user: state.auth.user,
    visible: state.header.visible,
    operations: state.swap.operations,
    search: state.swap.search,
    history: ownProps.history
  }
}, { fetchOperations, changeSwapSearch, changeHeaderVisible, profile, pinOperation, swapOperation })(Swap)

export default withParams(Swap)
